// extracted by mini-css-extract-plugin
module.exports = {"styledModal":"fkxKUlYf","content":"DTuvGElX"};